module.exports = __webpack_public_path__ + "static/media/ilustra-01.a9ef0d19.png";